import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../context/LanguageContext';

// Check if registration is disabled via environment variable
const isRegistrationDisabled = import.meta.env.VITE_DISABLE_REGISTRATION === 'true';

/**
 * Menu Component
 * Navigation menu for public pages
 */
const Menu = () => {
    const { t } = useTranslation();

    return (
        <nav className="hidden md:flex space-x-8 items-center">
            {!isRegistrationDisabled && (
                <>
                    <Link to="/discover" className="text-gray-600 hover:text-cabaza-purple font-medium transition-colors">
                        {t.nav?.discover || 'Discover Cabaza'}
                    </Link>
                    <Link to="/pricing" className="text-gray-600 hover:text-cabaza-purple font-medium transition-colors">
                        {t.nav?.pricing || 'Pricing'}
                    </Link>
                </>
            )}
            <Link to="/login" className="text-gray-600 hover:text-cabaza-purple font-medium transition-colors">
                {t.nav?.login || 'Se connecter'}
            </Link>
        </nav>
    );
};

export default Menu;
